import React from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";

export default function ImportIDsBar() {
  const importPreviews = useSelector(
    (state: RootState) => state.imports?.importPreviews,
    isEqual,
  );
  return (
    <div className={styles.container}>
      {importPreviews &&
        Object.entries(importPreviews).map(([type, preview]) => (
          <div key={type} className={styles.importID}>
            <span className={styles.importType}>{type.toUpperCase()}: </span>
            <span className={styles.importIDValue}>
              {preview?._id || "None"}
            </span>
          </div>
        ))}
    </div>
  );
}
